import React, { useState, useEffect } from 'react';
import '../../style/ChatModal.css';

const ChatModal = ({ sos, onClose, socketUrl, chatId }) => {
    const [message, setMessage] = useState('');
    const [chatHistory, setChatHistory] = useState([]);
    const [connectionStatus, setConnectionStatus] = useState('disconnected');
    const [socket, setSocket] = useState(null);
    const [senderId, setSenderId] = useState("");



    useEffect(() => {
        const ws = new WebSocket(`wss://chat.alertapp.kz/?token=${sos.token}&chatId=${sos.chatId}`);

        ws.onopen = () => {
            console.log('WebSocket connected');
            setConnectionStatus('connected');
        };

        ws.onmessage = (event) => {
            try {
                const data = JSON.parse(event.data);
                console.log('Received message:', data);


                if (data.text.length > 0 ) {
                    setChatHistory((prev) => [
                        ...prev,
                        {  text: data.text,  },
                    ]);
                }
            } catch (err) {
                console.error('Error parsing WebSocket message:', err);
            }
        };

        ws.onclose = () => {
            console.log('WebSocket disconnected');
            setConnectionStatus('disconnected');
        };

        ws.onerror = (error) => {
            console.error('WebSocket error:', error);
            if (error?.message) {
                console.error('Error message:', error.message);
            }

            if (error?.target?.url) {
                console.error('WebSocket URL:', error.target.url);
            }

            console.error('WebSocket instance:', error.target);
            setConnectionStatus('error');
        };

        // Закрываем WebSocket при размонтировании компонента
        setSocket(ws);
        return () => {
            ws.close();
        };
    }, [sos]);

    const handleSendMessage = () => {
        if (message.trim() && socket && socket.readyState === WebSocket.OPEN) {
            const newMessage = {
                type: 'message',
                text: message,
                sender: 'officer',
                timestamp: new Date(),
            };
            socket.send(JSON.stringify(newMessage)); // Отправляем сообщение через WebSocket
            setChatHistory([...chatHistory, newMessage]); // Добавляем в локальную историю
            setMessage('');
        } else {
            alert('Чат недоступен');
        }
    };


    return (
        <div className="chat-modal">
            <div className="chat-modal-content">
                <div className="header" style={{ display: 'flex', alignItems: 'center', marginBottom: 20 }}>
                    <h3>Чат с пользователем ({sos.user?.fullName || 'Неизвестно'})</h3>
                    <div className={`status-indicator ${connectionStatus}`}>
                        {connectionStatus === 'connected' && 'Подключено'}
                        {connectionStatus === 'disconnected' && 'Отключено'}
                        {connectionStatus === 'error' && 'Ошибка'}
                    </div>
                    <button onClick={onClose} className="close-button">X</button>
                </div>
                <div className="chat-history">
                    {chatHistory.map((msg, index) => (
                        <div key={index} className={`chat-message ${msg.sender}`}>
                            <p>{msg.text}</p>
                            <small>{new Date(msg.timestamp).toLocaleTimeString()}</small>
                        </div>
                    ))}
                </div>
                <div className="chat-input">
                    <input
                        type="text"
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        placeholder="Введите сообщение"
                    />
                    <button onClick={handleSendMessage}>Отправить</button>
                </div>
            </div>
        </div>
    );
};

export default ChatModal;
